import { API_BASE_URL } from "helpers/constants";
import { fetchWrapperPublic } from "helpers/fetch-wrapper";

export class TeamQueries {
    static async getTeamList(): Promise<Response> {
        return await fetchWrapperPublic.get(`${API_BASE_URL}/user/team/action`);
    }

    static async createTeamMember(data: any): Promise<Response> {
        return await fetchWrapperPublic.post(`${API_BASE_URL}/user/team/action`, data);
    }

    static async deleteTeamMember(id: string): Promise<Response> {
        return await fetchWrapperPublic.delete(`${API_BASE_URL}/user/team/action/${id}`);
    }
}

export async function getBusinessDetailsQuery(): Promise<Response> {
    return await fetchWrapperPublic.get(`${API_BASE_URL}/data/get-business/info`);
}

export async function setBusinessBankAccountQuery(data: any): Promise<Response> {
    return await fetchWrapperPublic.post(`${API_BASE_URL}/data/add-business-account`, data);
}